module.exports = __webpack_public_path__ + "img/ens-spec.1f14e922.jpg";